module.exports = __webpack_public_path__ + "static/media/pn.9f8d2c5b.svg";